var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getClassName, useIntegrationName } from '../../helpers';
import { TABLE_CELLS, TABLE_BODY_CELL, TABLE_BODY_ROW, TABLE_BODY_DESCRIPTION_ROW, TABLE_BODY_CELL_LINK, TABLE_BODY_CELL_SPAN, TABLE_BODY_BOOK_LINK_WAITING_LINK, TABLE_BODY_BOOK_NOW_LINK, TABLE_BODY_ROW_BOOKED_OUT, TABLE_BODY_ROW_WAITLIST, TABLE_BODY_ROW_EXPANDED, TABLE_BODY_ROW_FEW_PLACES_LEFT, } from '../../classConstants';
import { ECourseColumns } from '../../store/store';
import parse from 'html-react-parser';
import { UserList } from './UserList';
import { AppointmentsList } from './Appointments';
export var CourseRow = function (_a) {
    var columnHeaders = _a.columnHeaders, data = _a.data;
    var t = useTranslation().t;
    var integrationName = useIntegrationName();
    var _b = useState(false), showDescription = _b[0], setShowDescription = _b[1];
    var handleMoreButtonClick = function (e) {
        e.preventDefault();
        setShowDescription(!showDescription);
    };
    var renderMoreInfoButton = function (prop) {
        if (!data[prop])
            return null;
        return (React.createElement("a", { className: TABLE_BODY_CELL_LINK, href: "#", onClick: handleMoreButtonClick }, t('course_table.more_info')));
    };
    var renderBookNowButton = function (prop) {
        if (!data[prop])
            return t('course_table.fully_booked');
        var className = data.waitinglist ? TABLE_BODY_BOOK_LINK_WAITING_LINK : TABLE_BODY_BOOK_NOW_LINK;
        var label = data.waitinglist ? t('course_table.add_to_waiting_list') : t('course_table.book_now');
        return (React.createElement("a", { className: getClassName(TABLE_BODY_CELL_LINK, className), href: data[prop], "data-integration-name": integrationName }, label));
    };
    var renderRow = function () {
        var _a;
        var row = columnHeaders.map(function (_a) {
            var key = _a.key;
            var label = null;
            var className = getClassName(TABLE_BODY_CELL, TABLE_CELLS[key]);
            switch (key) {
                case 'id':
                    return label;
                case ECourseColumns.DESCRIPTION:
                    label = renderMoreInfoButton(ECourseColumns.DESCRIPTION);
                    break;
                case ECourseColumns.BOOKLINK:
                    label = renderBookNowButton(ECourseColumns.BOOKLINK);
                    break;
                case ECourseColumns.TRAINER:
                    label = React.createElement(UserList, { className: TABLE_BODY_CELL_SPAN, users: (data[key]) });
                    break;
                case ECourseColumns.APPOINTMENTS:
                case ECourseColumns.APPOINTMENT_LIST:
                    label = React.createElement(AppointmentsList, { placement: "course_table", className: TABLE_BODY_CELL_SPAN, data: data[key] });
                    break;
                default:
                    label = React.createElement("span", { className: TABLE_BODY_CELL_SPAN }, parse(data[key] || ''));
            }
            return (React.createElement("td", { className: className, key: data.id + key }, label));
        });
        var courseClassNames = data.courseNames.map(function (name) { return 'ws-course-' + name; });
        var tagClassNames = data.tagNames.map(function (name) { return 'ws-tags-' + name; });
        return (React.createElement("tr", { id: 'row' + data.id, className: getClassName.apply(void 0, __spreadArray(__spreadArray([TABLE_BODY_ROW, (_a = {},
                    _a[TABLE_BODY_ROW_BOOKED_OUT] = !data[ECourseColumns.BOOKLINK],
                    _a[TABLE_BODY_ROW_WAITLIST] = data.waitinglist,
                    _a[TABLE_BODY_ROW_EXPANDED] = showDescription,
                    _a[TABLE_BODY_ROW_FEW_PLACES_LEFT] = data.hasFewPlacesLeft,
                    _a)], courseClassNames), tagClassNames)) }, row));
    };
    var renderDescription = function () {
        if (!showDescription)
            return null;
        var rowClassName = getClassName(TABLE_BODY_ROW, TABLE_BODY_DESCRIPTION_ROW);
        var cellClassName = getClassName(TABLE_BODY_CELL, TABLE_CELLS[ECourseColumns.DESCRIPTION]);
        return (React.createElement("tr", { className: rowClassName },
            React.createElement("td", { className: cellClassName, colSpan: columnHeaders.length }, parse(data[ECourseColumns.DESCRIPTION] || ''))));
    };
    return (React.createElement(React.Fragment, null,
        renderRow(),
        renderDescription()));
};
